import { lazyLoad } from 'utils/loadable';

export const ListEnvironmentVariable = lazyLoad(
  () => import('./listEnvironment.page'),
  (module) => module.ListEnvironmentVariable
);
